import { ICON_TYPES } from '../constants';

export const ArtServiceThree = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66.203"
      height="79.218"
      viewBox="0 0 66.203 79.218"
    >
      <g
        id="Group_3"
        data-name="Group 3"
        transform="translate(-451.899 -764.892)"
      >
        <path
          id="Path_28"
          data-name="Path 28"
          d="M10.581,10.007a32.6,32.6,0,0,1,45.835,0,32.017,32.017,0,0,1,0,45.494L33.5,78.244,10.585,55.5A32.015,32.015,0,0,1,10.581,10.007Z"
          transform="translate(451.5 765)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_29"
          data-name="Path 29"
          d="M33.5,57.274A24.522,24.522,0,1,0,8.793,32.752,24.614,24.614,0,0,0,33.5,57.274Z"
          transform="translate(451.5 765)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_30"
          data-name="Path 30"
          d="M12.859,78.41H54.141"
          transform="translate(451.5 765)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_31"
          data-name="Path 31"
          d="M24.4,28.961H21.517a1.76,1.76,0,0,0-1.767,1.753v8.922a1.76,1.76,0,0,0,1.767,1.753H24.4a1.76,1.76,0,0,0,1.767-1.753V30.714A1.76,1.76,0,0,0,24.4,28.961Z"
          transform="translate(451.5 765)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M36.495,28.153V22.828a6.174,6.174,0,0,0-1.056-3.494,3.242,3.242,0,0,0-3.168-1.669c-3.09.4-1.786,3.39-1.747,4.354.033.854.209,2.892-2.888,5.183a3.589,3.589,0,0,0-1.46,2.873v9.634a1.682,1.682,0,0,0,1.688,1.676H41.7a1.99,1.99,0,0,0,1.969-1.643l1.61-9.265a1.992,1.992,0,0,0-1.969-2.323Z"
          transform="translate(451.5 765)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
    </svg>
  );
};

ArtServiceThree.iconType = ICON_TYPES.ART_SERVICE_THREE;
